import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Provider from "pubsub-js";
import {undoRedoSelector} from "../../selectors";
import {undo, redo, updateUndoRedo} from "../../AC/undo-redo";
import {HISTORY_ADD, HISTORY_CHANGED} from "../../constants/event-types";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import NoSsr from "@material-ui/core/NoSsr";
import UndoIcon from "@material-ui/icons/Undo";
import RedoIcon from "@material-ui/icons/Redo";
import {withStyles} from "@material-ui/core/styles";

const styles = {
  root: {
    borderRadius: `3px`
  }
};

export class UndoRedo extends Component {
  static propTypes = {
    undoRedo: PropTypes.shape({
      canUndo: PropTypes.bool,
      canRedo: PropTypes.bool
    }),
    undo: PropTypes.func,
    redo: PropTypes.func,
    updateUndoRedo: PropTypes.func,
    classes: PropTypes.object
  };
  undo = () => {
    this.props.undo();
  };
  redo = () => {
    this.props.redo();
  };
  updateUndoRedo = () => {
    this.props.updateUndoRedo();
  };
  componentDidMount() {
    this.historyAdd = Provider.subscribe(HISTORY_ADD, this.updateUndoRedo);
    this.historyChanged = Provider.subscribe(
      HISTORY_CHANGED,
      this.updateUndoRedo
    );
  }
  componentWillUnmount() {
    Provider.unsubscribe(this.historyAdd);
    Provider.unsubscribe(this.historyChanged);
  }
  render() {
    const {
      undoRedo: {canUndo, canRedo},
      classes
    } = this.props;
    return (
      <React.Fragment>
        <NoSsr>
          <div className="panel-control__item">
            <Tooltip title="Отменить (Ctrl+Z)">
              <div>
                <IconButton
                  onClick={this.undo}
                  disabled={!canUndo}
                  classes={{root: classes.root}}
                >
                  <UndoIcon />
                </IconButton>
              </div>
            </Tooltip>
          </div>
          <div className="panel-control__item">
            <Tooltip title="Повторить (Ctrl+Shift+Z)">
              <div>
                <IconButton
                  onClick={this.redo}
                  disabled={!canRedo}
                  classes={{root: classes.root}}
                >
                  <RedoIcon />
                </IconButton>
              </div>
            </Tooltip>
          </div>
        </NoSsr>
      </React.Fragment>
    );
  }
}

export default connect(
  (state) => ({
    undoRedo: undoRedoSelector(state)
  }),
  {
    undo,
    redo,
    updateUndoRedo
  }
)(withStyles(styles)(UndoRedo));
